module.exports = __webpack_public_path__ + "fonts/RenaultLife-Bold.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/fonts/latin-basic/RenaultLife-Bold.ttf
// module id = 349
// module chunks = 0